import { render, staticRenderFns } from "./ProofsDate.vue?vue&type=template&id=73c8693a&"
import script from "./ProofsDate.vue?vue&type=script&lang=ts&"
export * from "./ProofsDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports